import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import {
  useHistory,
} from "react-router-dom";
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';
import toast, { Toaster } from 'react-hot-toast';
import { ImWarning } from "react-icons/im";
import { HiOutlineClipboardCopy } from "react-icons/hi";
import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'

import {FirebaseContext} from '../services/Firebase/Context'
import {AuthContext} from '../services/Session/Context'

const Appointments = () => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext)
  const history = useHistory();
  const [records, setRecords] = useState([])
  const sharingURL = `${window.location.protocol}//${window.location.host}/appointments/${user.organisationId}`

  useEffect(() => {
    if(!user) return
    const q = query(
      collection(db, "appointments"),
      where("organisationId", "==", user.organisationId),
      where("status", "in", ["new", "accepted"]),
      orderBy("createdAt", 'desc'),
      limit(500))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        const eventData = doc.data()
        records.push({
          id: doc.id,
          title: eventData.name, 
          allDay: true,
          start: eventData.date.toDate(),
          color: eventData.status === 'new' ? "#93c5fd" : "#2563eb",
          ...doc.data()});
      });
      setRecords(records)
    });
    return () => unsubscribe()
  }, [db, user])
  
  if(user.organisation.offer !== 'Smart' && user.organisation.offer !== 'Premium') {
    return (
      <MainLayout>
        <UserInfos/>
        <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">
          Traitement des rendez-vous
        </h1>
        <div className="flex justify-center flex-col items-center mt-5 p-5">
          <ImWarning className="text-yellow-300 my-5" size={100}/>
          <p>Votre offre actuelle ne permet pas l'accès à cette fonctionnalité</p>
          <button
            type="button"
            className="py-2 px-4 mt-5 bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 focus:ring-offset-indigo-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
            onClick={() => window.location = `mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Changement d'offre&body=Mon compte :  ${user.firstName} ${user.lastName} (${user.organisation.name})`}
          >
            Passer à l'offre Smart
          </button>
        </div>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <UserInfos/>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">
        Traitement des rendez-vous
      </h1>
      <h2 className=" text-gray-400">Cliquez sur une date pour ajouter un rendez-vous ou sur un élément pour avoir les détails</h2>
      <p className="text-gray-400 text-sm">
        Partagez ce lien :&nbsp;
        <a target="_blank" rel='noreferrer nofollow' className="text-blue-500 underline hover:text-blue-700" href={sharingURL}>
          {sharingURL}
        </a>
        <span className='ml-1 text-blue-500 hover:text-blue-700 cursor-pointer' onClick={() => {
          navigator.clipboard.writeText(sharingURL)
          toast.success('Lien copié avec succès !');
        }}>
          <HiOutlineClipboardCopy className='inline text-lg'/>
          Copier
        </span>
        
      </p>
      <div className="w-full mt-5">
        <FullCalendar
          height='auto'
          dayMaxEvents={2}
          locale={frLocale}
          plugins={[ dayGridPlugin, listPlugin, interactionPlugin ]}
          headerToolbar={{center: 'title', start: 'dayGridMonth dayGridWeek listWeek' }}
          eventContent= {(arg) => <div className='p-1 cursor-pointer'>
            <b>{arg.event.title}</b>
            {arg.event.extendedProps.isBusiness && <i className='ml-1 text-yellow-600'>Pro</i>}
          </div>}
          events={records}
          eventClick={(e) => {
            history.push(`/app/appointments/${e.event.id}`)
          }}
          dateClick={(info) => {
            history.push(`/app/appointments/create`, {selectedDate: info.date})
          }}
        />
      </div>
      <Toaster />
    </MainLayout>
  );
}

export default Appointments
